import { ref } from "vue";
import { useRequestsStore } from '@/stores/storeRequests';
import { useSettingsStore } from '@/stores/storeSettings';
import { useFieldsStore } from "@/stores/storeFieldData";
import { sendMetrik } from '@/utils/metrika'

let modalsInstance; 

export const useModals = () => {

    if (modalsInstance) {
        return modalsInstance;
    }

    const activeModal = ref(false);
    const modalId = ref(null);    
    const modalObj = ref(null);

    const storeRequests = useRequestsStore()
    const storeSettings = useSettingsStore();
    const storeField = useFieldsStore();

    const disableScroll = () => {
        lockPadding();
        document.body.classList.add('noscroll');
    }
    
    const enableScroll = () => {
        document.body.classList.remove('noscroll');
        unlockPadding()
    }
   
    const lockPadding = () => {
        const paddingOffset = `${window.innerWidth - document.body.offsetWidth}px`;
        document.body.style.paddingRight = paddingOffset;
    }
    
    const unlockPadding = () => {
        document.body.style.paddingRight = '0px';
    }  

    const closeRegistration = () => {
        if(modalId.value === 'registration' && modalId.value !== 'registrationEnd') {
            sendMetrik('reachGoal', 'registration_failed');
            storeField.updateRegestrationBtn();
        }
    }
    

    const closeModal = () =>{
        activeModal.value = false;
        closeRegistration();
        modalId.value = null;
        enableScroll();
        storeRequests.responseError = '';
        if(storeRequests.isAuthenticated) {
            storeField.fields.email.disabledBtn = true
        }
    }

    const openModal = (id, object = null) => {
        closeModal();
        disableScroll();
        activeModal.value = true;
        modalId.value = id;   
        modalObj.value = object;     
    }
    
    const triggerQrScan = () => {
        const qrElement = document.getElementById('apm-scan-qr');
        // sendMetrik('reachGoal', 'klik_upload_reciept')
      
        setTimeout(() => {
            const closeApmBtn = document.getElementById('apm-close-widget-button');
            closeApmBtn?.addEventListener('click', () => {
                // sendMetrik('reachGoal', 'upload_close');
            })
        }, 1000)
        if (storeSettings.statusStockFuture) {
            openModal('promoNotStart');
        }
        if (storeSettings.statusStockPast) {
            openModal('promoEnd');
        }
        if (qrElement && storeRequests.isAuthenticated && storeSettings.statusStockActive) {
            qrElement.click();
            // if(storeRequests.userData?.receipt_status === 'upload_available') {
            //     qrElement.click();
            // } else {
            //     openModal('downloadReceiptsEnd');
            // }
        } 
        if (!storeRequests.isAuthenticated && storeSettings.statusStockActive) {
            openModal('authorizationRequired')
        }  
    }

    return modalsInstance = { activeModal, modalId, modalObj, closeModal, openModal, triggerQrScan };
   
}